<template>
  <div class="page-container bg-light-gray page-container bg-white full-width">
    <h1>{{ $t("newsTitle") }}</h1>
    <ul class="news-list">
      <news-item v-for="item in sortedNews" :key="item.id" :item="item"/>
    </ul>
  </div>
</template>

<script>
import NewsItem from '@/components/lists/NewsItem.vue'

export default {
  name: 'NewsPage',
  components: {
    NewsItem
  },
  metaInfo() {
    return {
      title: 'Kärnten Card App | ' + this.$t('newsTitle'),
      meta: [{
        property: 'og:title', content: 'Kärnten Card App | ' + this.$t('newsTitle')
      }, {
        property: 'og:site_name', content: 'Kärnten Card App'
      }, {
        property: 'og:url', content: window.location.href
      }, {
        property: 'og:image', content: "https://app.kaerntencard.at/img/kc-logo.png"
      }, {
        property: 'og:description', content: this.$t('newsDescription')
      }]
    }
  },
  computed: {
    news() {
      return this.$store.getters.getCurrentNews
    },
    sortedNews() {
      return this.news.slice().sort((a, b) => {
        if (a.post_date > b.post_date) {
          return -1
        }
        if (a.post_date < b.post_date) {
          return 1
        }

        return 0
      })
    }
  },
  created() {
    // try to fetch news if there are no news in the store
    if (this.news.length <= 0) {
      this.$store.dispatch('fetchNews', {lang: this.$store.state.language, season: this.$store.state.season})
    }
  },
  watch: {
    '$store.state.season': function() {
      this.$store.dispatch('fetchCardInfos', {lang: this.$store.state.language, season: this.$store.state.season})
          .then(() => {
            this.$store.dispatch('fetchNews', {lang: this.$store.state.language, season: this.$store.state.season})
          })
          .catch(err => console.log(err))
    },
    '$store.state.language': function() {
      this.$store.dispatch('fetchCardInfos', {lang: this.$store.state.language, season: this.$store.state.season})
          .then(() => {
            this.$store.dispatch('fetchNews', {lang: this.$store.state.language, season: this.$store.state.season})
          })
          .catch(err => console.log(err))
    },
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 1.85rem;
  font-weight: bold;
  text-align: center;
  margin-top: 2rem;
}

.news-list {
  list-style: none;
  margin: 0;
  padding: 0;

  @include flex();
  @include xy-grid();
  @include xy-grid-layout(1, '.news-item', false, 0);

  @include breakpoint(medium) {
    @include xy-grid-layout(2, '.news-item');
  }

  @include breakpoint(large) {
    @include xy-grid-layout(4, '.news-item');
  }

  @include breakpoint(xlarge) {
    @include xy-grid-layout(4, '.news-item');
  }
}
</style>
